export const WORKER_STATUSES = ['available', 'deployed', 'unavailable'];
export const DOC_TYPES = [
    'Drawings',
    'Method Statement',
    'Risk Assessment',
    'Programme',
    'Contract',
    'H&S Plan',
    'Insurance',
    'Correspondence',
    'Photo',
    'Other',
];
export const DEPLOY_DURATIONS = [
    '1 day',
    '2 days',
    '3 days',
    '4 days',
    '5 days',
    '1 week',
    '2 weeks',
    '1 month',
    '6 weeks',
    '2 months',
    'Until project end',
];
export const SUPPLIER_CATEGORIES = [
    'Plant & Equipment',
    'Materials',
    'PPE & Safety',
    'Subcontractor',
    'Waste & Logistics',
    'Training',
    'Consultants',
    'Other',
];
export const CONTACT_TYPES = [
    'Customer',
    'Worker',
    'Supplier',
    'Contractor',
    'Consultant',
    'Internal',
    'Other',
];
export const CONTACT_TYPE_COLORS = {
    Customer: '#E8A427',
    Worker: '#22C55E',
    Supplier: '#3B82F6',
    Contractor: '#8B5CF6',
    Consultant: '#EC4899',
    Internal: '#A3B0C9',
    Other: '#6B7A99',
};
export const CALENDAR_PROJECT_PALETTE = [
    '#E8A427',
    '#22C55E',
    '#3B82F6',
    '#8B5CF6',
    '#EF4444',
    '#06B6D4',
    '#F97316',
    '#10B981',
    '#EC4899',
    '#14B8A6',
];
export const AVATAR_COLORS = CALENDAR_PROJECT_PALETTE;
export const DEFAULT_AGENCIES = [
    { code: 'ASHBROOKE', name: 'Ashbrooke Recruitment Ltd' },
    { code: 'MPL', name: 'MPL Staffing Solutions' },
    { code: 'KINGWOOD', name: 'Kingwood Agency' },
    { code: 'DGP', name: 'DGP Group' },
    { code: 'OPEN', name: 'Open Labour Ltd' },
    { code: 'FAIRMEAD', name: 'Fairmead Labour' },
];
export const DEFAULT_GEOFENCE_RADIUS_M = 100;
export const DEFAULT_OVERTIME_THRESHOLD_HOURS = 12;
export const AVAILABILITY_SIGNAL_WINDOW_HOURS = 72;
export const CERT_EXPIRING_WINDOW_DAYS = 90;
export const VISA_EXPIRING_WINDOW_DAYS = 90;
export const BROADCAST_STAGGER_MS = 600;
export const COMPANY_NAME = 'Construction Logistics Services';
//# sourceMappingURL=misc.js.map